import React from 'react';
import * as S from './DealRoomSection.styles';
import { Typography } from 'antd';

const { Title, Text } = Typography;

export const SmartChoice: React.FC = () => {
  return (
    <S.Wrapper>
      <S.ContentTextWrapper>
        <Title level={2} className="main-title regular">{`חיסכון בזמן, תהליך פשוט וכיסוי שמותאם לכם.`}</Title>
        <S.ListWrapper>
          <S.ListItem>
            <Text className="title">{`דרישת מיגון בפוליסה: `}</Text>
            {`אין כלל דרישות מיגון בפוליסה, לא לסיכון אש, לא לנזקים, ולא לעמדות טעינה של רכב חשמלי בחניון התת קרקעי.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`נזקי טבע (למעט רעידת אדמה): `}</Text>
            {`השתתפות עצמית בסך 1,200 ש"ח בלבד.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`מצלמה תרמית לאיתור נזילות: `}</Text>
            {`ללא תוספת מחיר מעבר להשתתפות העצמית.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`נזק נלווה של נזקי מים: `}</Text>
            {`ללא תוספת מחיר מעבר להשתתפות העצמית.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`נזק צנרת מדירה לרכוש המשותף: `}</Text>
            {`יש כיסוי לנזק מים הנגרם מדירה ופגע ברכוש המשותף.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`כפל השתתפות עצמית: `}</Text>
            {`במידה ובחרתם להפעיל כיסוי גם של צד ג' וגם של מבנה תשלמו פעם אחת השתתפות, אין כפל השתתפות עצמית.`}
          </S.ListItem>
          <S.ListItem>
            <Text className="title">{`כפל השתתפות עצמית בנוגע למתחם של בניינים החולקים שטח משותף: `}</Text>
            {`אין כפל השתתפות עצמית לבניינים החולקים שטח משותף עם בניינים אחרים. לדוגמה: אדם נפל בחניון התת קרקעי המשותף של המתחם, יצוין השתתפות עצמית אחת בלבד לכולם. כל המתחם החולק שטח משותף צריך להיכנס באותו היום – (התנאי לקבל את ההטבה לביטוח עם אותם הכיסויים).`}
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </S.Wrapper>
  );
};
